import React, { useEffect, useState } from "react";
import api from "../../../../../api/axios";

const EditRoomType = ({ roomType, onUpdated }) => {
  const [roomTypeName, setroomTypeName] = useState("");

  useEffect(() => {
    if (roomType) {
      setroomTypeName(roomType.name || "");
    }
  }, [roomType]);

  const handleEditRoomType = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        name: roomTypeName,
        active: true,
      };
      const result = await api.put(`/pms/room-type/${roomType.id}`, payload);
      setroomTypeName("");
      onUpdated();
    } catch (error) {
      console.error("Add roomType failed:", error);
    }
  };

  return (
    <div
      className="modal fade"
      id="edit-roomType"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">Edit Room Type</h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form onSubmit={handleEditRoomType}>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label text-muted">Room Type</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue="Delicious Food"
                  value={roomTypeName}
                  onChange={(e) => setroomTypeName(e.target.value)}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="submit" className="btn btn-primary">
                Update changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditRoomType;
